// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"227":"2c53660e","596":"4d955943"}[chunkId] + ".css";
};